import React, { FC, MouseEvent, memo, useState } from 'react';
import { Menu, MenuItem, SxProps, Tooltip } from '@mui/material';
import { GridSortDirection } from '@mui/x-data-grid';
import SortIcon from '@mui/icons-material/Sort';

import { StyledButton } from './styles';
import { SortingItem } from '@services';

interface SortingButtonProps {
  options: SortingItem[];
  onSelect: (sortBy: string, sortDirection: GridSortDirection) => void;
  customFilterSx?: SxProps;
}

const SortingButton: FC<SortingButtonProps> = memo(({ options, onSelect, customFilterSx }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);

  const [selectedItemName, setSelectedItemName] = useState<string | null>(null);

  const onClickSort = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);

  const onCloseMenu = () => setAnchorEl(null);

  const onClickItem = (name: any, sortBy: string, sortDirection: GridSortDirection) => () => {
    if (selectedItemName === name) {
      setSelectedItemName(null);
      onSelect('', null);
      setAnchorEl(null);
      return;
    }

    setSelectedItemName(name);
    onSelect(sortBy, sortDirection);
    setAnchorEl(null);
  };

  return (
    <>
      <StyledButton
        sx={{ ...customFilterSx }}
        variant="outlined"
        onClick={onClickSort}
        color="black"
        className={menuOpen || !!selectedItemName ? 'active' : ''}
      >
        <Tooltip title={selectedItemName || 'Add sorting'}>
          <SortIcon />
        </Tooltip>
      </StyledButton>
      <Menu anchorEl={anchorEl} open={menuOpen} onClose={onCloseMenu}>
        {options.map(({ name, sortBy, sortDirection }) => (
          <MenuItem
            key={name}
            selected={selectedItemName === name}
            onClick={onClickItem(name, sortBy, sortDirection)}
          >
            {name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});

export default SortingButton;
